export const I18n = {
	'en': {
		companies: {
			title: "Statistics by companies",
			placeholder: "Search...",
			dateFrom: 'From Date',
			dateTo: 'To Date',
			filter: "Filtering",
			resetFilter: "Reset filters",
			traderName: 'Trader',
			admin: 'Admin',
			tt: 'TT',
			activeTT: 'Active TT',
			devices: 'Devices',
			apps: 'Apps',
            download: 'Download CSV',
			downloadConnectedStoresCsv: 'Connected stores CSV'

		},
		company: {
			title: "Statistics by company",
			placeholder: "Search...",
			dateFrom: 'From Date',
			dateTo: 'To Date',
			filter: "Filtering",
			resetFilter: "Reset filters",
			name: 'Sales Point',
			devices: 'Devices',
			apps: 'Apps',
			download: 'Download CSV'

		},
		point: {
			title: "Statistics by sales point",
			placeholder: "Search...",
			dateFrom: 'From Date',
			dateTo: 'To Date',
			filter: "Filtering",
			resetFilter: "Reset filters",
			producer: 'Name',
			model: 'Model',
			imei: 'Imei',
			serial: 'Serial',
			version: 'Android Ver',
			pack: 'Package',
			status: 'Status',
			install: 'Install'
		},
		points: {
			title: "Statistics by sales points",
			placeholder: "Search...",
			dateFrom: 'From Date',
			dateTo: 'To Date',
			filter: "Filtering",
			resetFilter: "Reset filters",
			name: 'Sales Point',
			company: 'Select company',
			companyName: 'Company',
			all: 'All',
			city: 'City',
			address: 'Address',
			apps: 'Apps',
			devices: 'Devices',
			download: 'Download CSV'
		},
		apps: {
			title: "Statistics by apps",
			placeholder: "Search...",
			dateFrom: 'From Date',
			dateTo: 'To Date',
			filter: "Filtering",
			resetFilter: "Reset filters",
			app: 'App',
			packs: 'Packages',
			numbers: 'Number',
			company: 'Select company',
			all: 'All',
			salesPoint: 'Sales Point'
		},
		geoActivity: {
			title: "Geo activity",
			dateFrom: 'From Date',
			dateTo: 'To Date',
			filter: "Filter",
			resetFilters: "Reset filters",
			downloadCsv: 'Download csv',
			company: 'Company',
			salesPoint: 'Sales Point',
			city: 'City',
			address: 'Address',
			user: 'User',
			userPhone: 'User phone',
			workTime: 'Work time',
			firstActivity: 'First activity',
			lastActivity: 'Last activity',
			date: 'Date',
			toStore: 'To store',
			checkInOutTitle: 'To verify working hours, scan the QR and grant access to geolocation on your smartphone',
			userHasToBeConnectedToSingleStore: 'User has to be connected to a single sales point',
			storeMustHaveMaximumOneOperator: 'Store must have maximum one operator',
			open: 'Open',
			updateLocation: 'Update location',
			airAlarm: 'Air alarm',
			airAlarmWithDescription: 'Air alarm (leave a check mark if an air alarm occurs during authorization)',
			comment: 'Comment',
			commentPlaceholder: 'Leave a comment (it will be pinned to the day you left it)',
		},
		general: {
            title: 'General report',
			userName: 'User',
			salesPointName: 'SP',
			producer: 'Name',
			model: 'Model',
			imei: 'IMEI',
			serial: 'Serial',
			version: 'Version',
			time: 'Time',
			companies: 'Companies',
			contactUsToAccessThis: "Contact info@hankuper.com to access this functionality"
		}

	},
	'ru': {
		companies: {
			title: "Статистика по организациям",
			placeholder: "Поиск...",
			dateFrom: 'C даты',
			dateTo: 'По дату',
			filter: "Применить фильтры",
			resetFilter: "Сбросить фильтры",
			traderName: 'Торовая сеть',
			admin: 'Администратор',
			tt: 'Кол-во ТТ',
			activeTT: 'Активных TT',
			devices: 'Девайсы',
			apps: 'Приложения',
			download: 'Выгрузить в CSV',
			downloadConnectedStoresCsv: 'Подключенные торговые точки CSV'
		},
		company: {
			title: "Статистика по компании",
			placeholder: "Поиск...",
			dateFrom: 'C даты',
			dateTo: 'По дату',
			filter: "Применить фильтры",
			resetFilter: "Сбросить фильтры",
			name: 'Торговая точка',
			devices: 'Девайсы',
			apps: 'Приложения',
			download: 'Выгрузить в CSV'
		},
		point: {
			title: "Статистика по торговой точке",
			placeholder: "Поиск...",
			dateFrom: 'C даты',
			dateTo: 'По дату',
			filter: "Применить фильтры",
			resetFilter: "Сбросить фильтры",
			producer: 'Производитель',
			model: 'Модель',
			imei: 'Imei',
			serial: 'Серийный номер',
			version: 'Версия Андроид',
			pack: 'Пакет',
			status: 'Статус',
			install: 'Установка'
		},
		points: {
			title: "Статистика по торговым точкам",
			dateFrom: 'C даты',
			dateTo: 'По дату',
			city: 'Город',
			address: 'Адрес',
			company: 'Выбор компании',
			companyName: 'Компания',
			all: 'Все',
			placeholder: "Поиск...",
			filter: "Применить фильтры",
			resetFilter: "Сбросить фильтры",
			name: 'Торговая точка',
			apps: 'Приложения',
			devices: 'Девайсы',
			download: 'Выгрузить в CSV'
		},
		apps: {
			title: "Статистика по приложениям",
			placeholder: "Поиск...",
			dateFrom: 'C даты',
			dateTo: 'По дату',
			filter: "Применить фильтры",
			resetFilter: "Сбросить фильтры",
			app: 'Приложение',
			packs: 'Пакеты',
			numbers: `Кол-во
					установок`,
			company: 'Выбор компании',
			all: 'Все',
			salesPoint: 'Торговая точка'
		},
		geoActivity: {
			title: "Geo активность",
			dateFrom: 'C даты',
			dateTo: 'По дату',
			filter: "Применить фильтры",
			resetFilters: "Сбросить фильтры",
			downloadCsv: 'Выгрузить в CSV',
			company: 'Компания',
			salesPoint: 'Торговая точка',
			city: 'Город',
			address: 'Адрес',
			user: 'Пользователь',
			userPhone: 'Тел. пользователя',
			workTime: 'Рабочее время',
			firstActivity: 'Первая активность',
			lastActivity: 'Последняя активность',
			date: 'Дата',
			toStore: 'До магазина',
			checkInOutTitle: 'Для веріфікації робочого часу відскануйте QR та надайте доступ до геолокації на смартфоні',
            userHasToBeConnectedToSingleStore: 'Користувач повинен бути підключений до однієї торгової точки',
			storeMustHaveMaximumOneOperator: 'У магазина повинен бути максимум один оператор',
			open: 'Відкрити',
			updateLocation: 'Обновить локацию',
			airAlarm: 'Повітряна тривога',
			airAlarmWithDescription: 'Повітряна тривога (залиште відмітку, якщо під час авторизації йде повітряна тривога)',
			comment: 'Коментар',
			commentPlaceholder: 'Залишити коментар (він буде закріплений за днем, коли ви його залишили)',
		},
        general: {
            title: 'Общий отчет',
			userName: 'Пользователь',
			salesPointName: 'ТТ',
			producer: 'Производитель',
			model: 'Модель',
			imei: 'IMEI',
			serial: 'Номер',
			version: 'Версия',
			time: 'Дата',
			companies: 'Кампании',
			contactUsToAccessThis: "Для доступа к данному функционалу - обратитесь по адресу info@hankuper.com"
        },
	},
	'sk': {
		companies: {
			title: "Štatistiky podľa spoločnosti",
			placeholder: "Vyhľadávanie...",
			dateFrom: 'Od dátumu',
			dateTo: 'Randiť',
			filter: "Filtrovanie",
			resetFilter: "Resetu filtre",
			traderName: 'Obchodník',
			admin: 'Admin',
			tt: 'ТТ',
			activeTT: 'Aktívny TT',
			devices: 'Prístroje',
			apps: 'Aplikácie',
			download: 'Download csv',
			downloadConnectedStoresCsv: 'Pripojené obchody CSV'
		},
		company: {
			title: "Štatistiky podľa spoločnosti",
			placeholder: "Vyhľadávanie...",
			dateFrom: 'Od dátumu',
			dateTo: 'Randiť',
			filter: "filtrovanie",
			resetFilter: "resetu filtre",
			name: 'Sales Point',
			devices: 'Prístroje',
			apps: 'Aplikácie',
			download: 'Na stiahnutie vo formáte CSV'
		},
		point: {
			title: "Štatistiky podľa predajného miesta",
			placeholder: "Vyhľadávanie...",
			dateFrom: 'Od dátumu',
			dateTo: 'Randiť',
			filter: "Filtrovanie",
			resetFilter: "Resetu filtre",
			producer: 'Názov',
			model: 'Model',
			imei: 'IMEI',
			serial: 'Sériový',
			version: 'Android Ver',
			pack: 'Balíček',
			status: 'Postavenie',
			install: 'Inštalovať'
		},
		points: {
			title: "Štatistiky podľa predajných miest",
			dateFrom: 'Od dátumu',
			dateTo: 'Randiť',
			city: 'Veľkomesto',
			address: "Adresu",
			company: 'Výber spoločnosti',
			companyName: 'Spoločnosti',
			placeholder: "Vyhľadávanie...",
			filter: "Filtrovanie",
			resetFilter: "Resetu filtre",
			name: 'Sales Point',
			apps: 'Aplikácie',
			devices: 'Prístroje',
			download: 'Na stiahnutie vo formáte CSV',
			all: 'Všetko',
		},
		apps: {
			title: "Štatistiky podľa aplikácií",
			placeholder: "Vyhľadávanie...",
			dateFrom: 'Od dátumu',
			dateTo: 'Randiť',
			filter: "Filtrovanie",
			resetFilter: "Resetu filtre",
			app: 'App',
			packs: 'balíčky',
			numbers: 'číslo',
			company: 'Výber spoločnosti',
			all: 'Všetko',
			salesPoint: 'Sales Point'
		},
		geoActivity: {
			title: "Geo activity",
			dateFrom: 'From Date',
			dateTo: 'To Date',
			filter: "Filter",
			resetFilters: "Reset filters",
			downloadCsv: 'Download csv',
			company: 'Company',
			salesPoint: 'Sales Point',
			city: 'City',
			address: 'Address',
			user: 'User',
			userPhone: 'User phone',
			workTime: 'Work time',
			firstActivity: 'First activity',
			lastActivity: 'Last activity',
			date: 'Date',
			toStore: 'To store',
            checkInOutTitle: 'To verify working hours, scan the QR and grant access to geolocation on your smartphone',
            userHasToBeConnectedToSingleStore: 'User has to be connected to a single sales point',
			storeMustHaveMaximumOneOperator: 'Store must have maximum one operator',
			open: 'Open',
			updateLocation: 'Update location',
			airAlarm: 'Air alarm',
			airAlarmWithDescription: 'Air alarm (leave a check mark if an air alarm occurs during authorization)',
			comment: 'Comment',
			commentPlaceholder: 'Leave a comment (it will be pinned to the day you left it)',
		},
		general: {
			title: 'Všeobecná správa',
			userName: 'Užívateľ',
			salesPointName: 'ТТ',
			producer: 'Výrobca',
			model: 'Model',
			imei: 'IMEI',
			serial: 'číslo',
			version: 'Verzia',
			time: 'Dátum',
			contactUsToAccessThis: "Ak chcete získať prístup k tejto funkcii, kontaktujte info@hankuper.com"
		}
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/statistics/index.js